"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEmailTemplate = exports.createEmailTemplate = exports.getSingleEmailTemplate = exports.getEmailTemplates = void 0;
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const config_1 = __importDefault(require("../utils/config"));
const constants_1 = require("../constants");
const { zenithConfigApi } = (0, config_1.default)();
const baseURL = `${zenithConfigApi}${constants_1.routes.EMAIL_TEMPLATES}`;
const getEmailTemplates = ({ emailTemplateId = '', page = undefined, limit = undefined, search = '', filter = {}, onlyTenants = false, onlyLocales = false, }) => () => {
    let url = '';
    if (emailTemplateId && emailTemplateId !== '') {
        url = `${baseURL}/${emailTemplateId}`;
    }
    if (page || limit) {
        url = `${baseURL}?page=${page}&limit=${limit}`;
    }
    if (search && search !== '') {
        url = `${baseURL}?page=${page}&limit=${limit}&search=${search}`;
    }
    if (Object.keys(filter).length > 0) {
        url = `${baseURL}?page=${page}&limit=${limit}&search=${search}&filterBy=${JSON.stringify(filter)}`;
    }
    if (onlyTenants) {
        url = `${baseURL}?onlyTenants=true`;
    }
    if (onlyLocales) {
        url = `${baseURL}?onlyLocales=true`;
    }
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getEmailTemplates = getEmailTemplates;
/**
 * Axios wrapper function to fetch one or more email templates based on tenantId & locale code
 *
 * @param tenantId - Optional param to supply a tenant ID to fetch data for that item
 * @param localeCode - Optional param to supply a locale code to fetch data for that item
 * @param emailTemplateCode - Optional param to supply a email template code to fetch data for that item
 */
const getSingleEmailTemplate = (tenantId, localeCode, emailTemplateCode) => () => {
    const url = (localeCode === '' || emailTemplateCode === '')
        ? `${baseURL}?tenantId=${tenantId}`
        : `${baseURL}?tenantId=${tenantId}&localeCode=${localeCode}&emailTemplateCode=${emailTemplateCode}`;
    return zenithApiPrivate_1.default.get(url)
        .then((res) => res.data.data);
};
exports.getSingleEmailTemplate = getSingleEmailTemplate;
/**
 * Axios wrapper function to create a new email templates
 *
 * @param emailTemplate - data for a new email templates
 */
const createEmailTemplate = (emailTemplate) => (zenithApiPrivate_1.default.post(baseURL, emailTemplate)
    .then((res) => res));
exports.createEmailTemplate = createEmailTemplate;
/**
 * Axios wrapper function to update an existing email templates
 *
 * @param emailTemplate - update information for the email templates
 */
const updateEmailTemplate = (emailTemplate) => {
    const url = `${baseURL}/${emailTemplate.emailTemplatesId}`;
    return zenithApiPrivate_1.default.put(url, emailTemplate)
        .then((res) => res);
};
exports.updateEmailTemplate = updateEmailTemplate;
